import {
  isMobileStyleMixin,
  Button as StormButton,
  TextButton as StormTextButton,
  Theme,
  MenuItemLink as StormMenuItemLink,
} from '@amzn/storm-ui';
import styled, { css } from 'styled-components';

export const InfoText = styled.span`
  font-size: 13px;
  color: #767676;
`;

export const SpinnerWrap = styled.span`
  margin-right: 5px;
`;

export const ActionButtonsWrap = styled.div`
  display: flex;
  align-items: center;
  ${isMobileStyleMixin(css`
    flex-direction: column;
    gap: 14px;
    width: 100%;
  `)}
`;

export const ActionItemWrap = styled.span`
  margin: 0 14px 0 0;
  &:last-of-type {
    margin-right: 0;
  }
  ${isMobileStyleMixin(css`
    margin: 0;
    width: 100%;
  `)}
`;

export const ActionLinkItemWrap = styled(ActionItemWrap)`
  margin-left: 7px;
`;

export const ErrorMessageWrap = styled.div`
  &:empty {
    display: none;
  }
`;

export const HelpIcon = styled.span`
  font-size: 16px;
  position: relative;
  top: 1px;
  color: #232f3e;
`;

export const ActionLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  vertical-align: middle;
`;

export const Button = styled(StormButton)`
  ${isMobileStyleMixin(css`
    width: 100%;
  `)}
`;

export const TextButton = styled(StormTextButton)`
  ${isMobileStyleMixin(css`
    width: 100%;
  `)}
`;

export const adaptiveHelpTipThemeOverride = (theme: Theme): Theme => ({
  ...theme,
  popover: {
    ...theme.popover,
    zIndex: 501,
  },
});

export const MenuItemLink = styled(StormMenuItemLink)`
  :hover {
    text-decoration: none;
  }
`;
